var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sop_dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.isDialogShow,
        center: "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isDialogShow = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "border-radius": "0 !important" },
          attrs: {
            data: _vm.dialogTableData,
            border: "",
            "header-cell-style": { background: "#f7f7f9" },
          },
        },
        [
          _vm._l(_vm.tableHeaderList, function (item, idx) {
            return _c("el-table-column", {
              key: idx,
              attrs: {
                align: "center",
                label: item.label,
                prop: item.prop,
                "min-width": item.cloWidth,
              },
            })
          }),
          _vm.dialogType === 2
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                  width: "235",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", round: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.preView(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("operationCenter.Preview")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", round: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.download(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2539536708
                ),
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }